import { createRequest } from '../Helpers/GenericHelpers'
import { getTokenFromSessionStorage } from '../Helpers/TokenHelper'
import store from '../store'

const getTranslation = () => {
  const state = store.getState()

  const token = getTokenFromSessionStorage()
  return createRequest(
    '/api/startup/translation/' + state.present.language.current + '/',
    'GET',
    undefined,
    token,
  ).then(response => response.json())
}

const getMultiCompany = () => {
  const state = store.getState()

  const token = getTokenFromSessionStorage()
  return createRequest(
    '/api/startup/multicompany/?config=' + state.present.article.serverConfig,
    'GET',
    undefined,
    token,
  ).then(response => response.json())
}

export { getTranslation, getMultiCompany }
